import axiosInstance from "../../../services/axiosInstance";



export const getServiceGroup = async (id, params = {}) => {
    const response = await axiosInstance.get(`services/groups/${id}`,  {params} );
    return response.data;
};

export const getServitorCompany = async (id,params = {}) => {
    const response = await axiosInstance.get(`services/servitor-companies/${id}`,  {params} );
    return response.data;
};

export const getService = async (id,params = {}) => {
    const response = await axiosInstance.get(`services/services/${id}`,  {params} );
    return response.data;
};
